import { LoadingButton } from '@mui/lab'
import {
    Box,
    Button,
    Container,
    Grid,
    Stack,
    styled,
    TextField,
    Typography,
    Zoom,
} from '@mui/material'
import { decryptKeypair } from 'account/Encryption'
import { useState } from 'react'
import { ReactComponent as UnlockPageVector } from '../../assets/images/unlock-page.svg'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { selectMnemonic, setRawMnemonic } from '../../redux/slices/accountSlice'
import LogoutModal from '../Modals/Logout'
import ConfirmLogout from '../Modals/ConfirmLogout'

interface IProps {
    open: boolean
    handleClose: () => void
}

const PageWrapper = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    zIndex: 9999,
    position: 'absolute',
    top: 0,
    right: 0,
    // width: '100vw',
    height: '100vh',
    padding: theme.spacing(5),
}))

export default function UnlockPage(props: IProps): JSX.Element {
    const { open, handleClose } = props

    // State
    const [confirmLogoutModal, setConfirmLogoutModal] = useState(false)
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [logoutModal, setLogoutModal] = useState(false)

    // Redux
    const encryptedMnemonic = useAppSelector(selectMnemonic)
    const dispatch = useAppDispatch()
    // Functions
    const handleLogin = async (): Promise<void> => {
        try {
            setLoading(true)
            if (!password) throw new Error('لطفا رمزعبور را وارد کنید')

            if (!encryptedMnemonic) {
                handleClose()
                return
            }

            const mnemonic = decryptKeypair(encryptedMnemonic, password)

            if (!mnemonic) {
                throw new Error('105')
            }

            dispatch(setRawMnemonic(mnemonic))
            handleClose()
        } catch (err) {
            console.log('error', err)
            const errObj = err as Error
            switch (errObj.message) {
                case '105':
                    setError('رمزعبور اشتباه می‌باشد.')
                    break

                default:
                    setError(errObj.message)
                    break
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <Zoom in={open}>
            <PageWrapper container justifyContent="center">
                <Stack
                    display="flex"
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="center"
                    width="100%"
                >
                    <Container maxWidth="xs">
                        <Box width="100%" flexGrow={1}>
                            <UnlockPageVector />
                        </Box>

                        <Typography sx={{ my: 2 }}>
                            لطفا رمزعبور خود را وارد کنید.
                        </Typography>

                        <Stack flexBasis="100%" flexGrow={1} width="100%">
                            <TextField
                                fullWidth
                                id="password"
                                label="رمزعبور"
                                name="password"
                                type="password"
                                helperText={error}
                                error={!!error}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={(evt) => {
                                    if (evt.key === 'Enter') handleLogin()
                                }}
                            />

                            <LoadingButton
                                loading={loading}
                                variant="contained"
                                sx={{ my: 2 }}
                                onClick={handleLogin}
                            >
                                ورود
                            </LoadingButton>

                            <Button
                                color="error"
                                variant="text"
                                sx={{ mt: 1 }}
                                onClick={() => setLogoutModal(true)}
                                fullWidth
                            >
                                خروج از حساب
                            </Button>

                            {/* Logout Modal */}
                            <LogoutModal
                                open={logoutModal}
                                handleClose={() =>
                                    setLogoutModal((prev) => !prev)
                                }
                                onSubmit={() => {
                                    setConfirmLogoutModal(true)
                                    setLogoutModal(false)
                                }}
                            />

                            {/* Confirm Logout Modal */}
                            <ConfirmLogout
                                open={confirmLogoutModal}
                                handleClose={() =>
                                    setConfirmLogoutModal((prev) => !prev)
                                }
                            />
                        </Stack>
                    </Container>
                </Stack>
            </PageWrapper>
        </Zoom>
    )
}
